export const TABLE_PARAMS = {
    sortParam: {
        default: 'BY_DATE',
    },
    size: {
        default: 15,
        getValue: v => Number(v),
    },
}
